export default {
  title: 'Actualizar perfil de {{name}}',
  form: {
    name: {
      label: 'Nombre',
      placeholder: 'Introduce el nombre completo del propietario',
    },
    email: {
      label: 'Correo electrónico',
      placeholder: 'Introduce el correo personal del propietario',
      tooltip: 'Correo personal del propietario/gerente del restaurante. Se usa como acceso al panel',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Los cambios se han guardado',
  },
};
